import { Injectable } from '@angular/core';
import { TimeFilter, SBVDisplayType, BetTypeNameDisplayType, BetTypeOutcomeShowType, EventType, OfficeNumberRounding, EventMappingType, PageType, BetOrderingType, TicketFilterStatus, SpecialOfferType } from 'src/app/models/enums';
import { EventVM } from 'src/app/models/event/event';
import { IBet } from 'src/app/models/bet/bet';
import { IBetTypeShowTypeWithBets } from 'src/app/models/bet/betsAndBetTypeShowTypeWithOnlineStatus.interface';
import { IBetTypeShowType } from 'src/app/models/betType/betTypeShowType.interface';
import { IBetTypeGroup } from 'src/app/models/betType/betTypeGroup.interface';
import { IBetOutcome } from 'src/app/models/bet/betOutcome.interface';
import { IBetTypeOutcome } from 'src/app/models/betType/betTypeOutcome.interface';
import { IBetGroupWithBetToShowId } from 'src/app/models/bet/betGroupWithBetToShow.interface';
import { ConstantValues } from 'src/app/models/util/constantValues';
import { ITicketItemIdentifier } from 'src/app/models/ticket/ticketItemIdentfier.interface';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
import { DeployParams } from 'src/app/deployParams';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';
import { ConfirmationDialogComponent } from 'src/app/ticket-manager/components/confirmation-dialog/confirmation-dialog.component';
import { ITicketItemGroupPrintViewModel } from 'src/app/ticket-manager/models/print/ITicketItemGroupPrint.interface';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { environment } from 'src/environments/environment';
// import { MatDialog } from '@angular/material/dialog';
// import { database } from 'firebase';
// import * as pdfMake from 'pdfmake/build/pdfmake';
// import * as pdfFonts from 'pdfmake/build/vfs_fonts';
@Injectable()
export class UtilityService {
  private isMobileView = false;
  private isIOS = false;
  private scrWidth: number;

  constructor( ) {
    if (
      navigator.userAgent.match(/Windows Phone/i) ||
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/iPad/i)) {

      this.isMobileView = true;
    } else {
      this.isMobileView = false;
    }

    if (
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/iPad/i)) {

      this.isIOS = true;
    } else {
      this.isIOS = false;
    }

    // this.scrWidth = window.screen.width;
    this.scrWidth = window.innerWidth;
    // console.log(this.scrWidth);

    // added because on smaller screens we want to show mobile view
    if (this.scrWidth < 1025) {
      this.isMobileView = true;
    } else {
      this.isMobileView = false;
    }
  }

  get mobileView(): boolean {
    return this.isMobileView;
  }

  get iOS(): boolean {
    return this.isIOS;
  }

  get eventsDateToStringFormat(): Intl.DateTimeFormatOptions {
    if (this.mobileView) {
      return { weekday: 'short', month: '2-digit', day: '2-digit' };
    } else {
      return { weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit' };
    }
  }

  get ticketItemGroupDateToStringFormat(): Intl.DateTimeFormatOptions {
    if (this.mobileView) {
      return { weekday: 'short', month: '2-digit', day: '2-digit' };
    } else {
      return { weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit' };
    }
  }

  public getDateFromTo(isLive: boolean = false, timeFilterValue: TimeFilter = null): { dateFrom: Date; dateTo: Date } {
    const dates: { dateFrom: Date; dateTo: Date } = { dateFrom: null, dateTo: null };
    let dateFrom: Date = new Date();
    let dateTo: Date = null;
    // let dateOffsetUtc: number = dateFrom.getTimezoneOffset();
    const year: number = dateFrom.getFullYear();
    const month: number = dateFrom.getMonth();
    const day: number = dateFrom.getDate();
    const hour: number = dateFrom.getHours();
    const min: number = dateFrom.getMinutes();
    const sec: number = dateFrom.getSeconds();

    if (!isLive) {
      dateFrom.setSeconds(dateFrom.getSeconds() + 30);
      switch (timeFilterValue) {
        case TimeFilter.H1:
          dateTo = new Date(year, month, day, hour + 1, min, sec, 0);
          break;
        case TimeFilter.H3:
          dateTo = new Date(year, month, day, hour + 3, min, sec, 0);
          break;
        case TimeFilter.H6:
          dateTo = new Date(year, month, day, hour + 6, min, sec, 0);
          break;
        case TimeFilter.H12:
          dateTo = new Date(year, month, day, hour + 12, min, sec, 0);
          break;
        case TimeFilter.H24:
          dateTo = new Date(year, month, day + 1, hour, min, sec, 0);
          break;
        case TimeFilter.Today:
          dateTo = new Date(year, month, day, 23 + environment.timeFilterOffset, 59, 59, 999);
          break;
        case TimeFilter.D1:
          dateFrom = new Date(year, month, day + 1, environment.timeFilterOffset, 0, 0, 0);
          dateTo = new Date(year, month, day + 1, 23 + environment.timeFilterOffset, 59, 59, 999);
          break;
        case TimeFilter.D2:
          dateFrom = new Date(year, month, day + 2, environment.timeFilterOffset, 0, 0, 0);
          dateTo = new Date(year, month, day + 2, 23 + environment.timeFilterOffset, 59, 59, 999);
          break;
        case TimeFilter.D3:
          dateFrom = new Date(year, month, day + 3, environment.timeFilterOffset, 0, 0, 0);
          dateTo = new Date(year, month, day + 3, 23 + environment.timeFilterOffset, 59, 59, 999);
          break;
        case TimeFilter.D4:
          dateFrom = new Date(year, month, day + 4, environment.timeFilterOffset, 0, 0, 0);
          dateTo = new Date(year, month, day + 4, 23 + environment.timeFilterOffset, 59, 59, 999);
          break;
        case TimeFilter.D5:
          dateFrom = new Date(year, month, day + 5, environment.timeFilterOffset, 0, 0, 0);
          dateTo = new Date(year, month, day + 5, 23 + environment.timeFilterOffset, 59, 59, 999);
          break;
        case TimeFilter.D6:
          dateFrom = new Date(year, month, day + 6, environment.timeFilterOffset, 0, 0, 0);
          dateTo = new Date(year, month, day + 6, 23 + environment.timeFilterOffset, 59, 59, 999);
          break;
        case TimeFilter.ResultToday:
          dateFrom = new Date(year, month, day, 0, 0, 0, 0);
          dateTo = new Date();
          break;
        case TimeFilter.ResultD1:
          dateFrom = new Date(year, month, day - 1, 0, 0, 0, 0);
          dateTo = new Date(year, month, day - 1, 23, 59, 59, 999);
          break;
        case TimeFilter.ResultD2:
          dateFrom = new Date(year, month, day - 2, 0, 0, 0, 0);
          dateTo = new Date(year, month, day - 2, 23, 59, 59, 999);
          break;
        case TimeFilter.ResultD3:
          dateFrom = new Date(year, month, day - 3, 0, 0, 0, 0);
          dateTo = new Date(year, month, day - 3, 23, 59, 59, 999);
          break;
        case TimeFilter.ResultD4:
          dateFrom = new Date(year, month, day - 4, 0, 0, 0, 0);
          dateTo = new Date(year, month, day - 4, 23, 59, 59, 999);
          break;
        case TimeFilter.ResultD5:
          dateFrom = new Date(year, month, day - 5, 0, 0, 0, 0);
          dateTo = new Date(year, month, day - 5, 23, 59, 59, 999);
          break;
        case TimeFilter.ResultD6:
          dateFrom = new Date(year, month, day - 6, 0, 0, 0, 0);
          dateTo = new Date(year, month, day - 6, 23, 59, 59, 999);
          break;
        default: dateTo = new Date(year + 5, month, day, hour, min, sec, 0);
      }
    } else {
      dateFrom = new Date(year, month, day - 1, hour, min, sec, 0);
      dateTo = new Date(year, month, day, hour, min + 10, sec, 0);
    }
    dates.dateFrom = dateFrom;
    dates.dateTo = dateTo;
    return dates;
  }

  public groupBy(xs, f) {
    return xs.reduce((r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r), {});
  }

  public sortEventsByDateAndCode(events: EventVM[]): EventVM[] {
    if (!events || events.length < 2) {
      return events;
    } else {
      events.sort((e1, e2) => {
        if (e1.dateTime > e2.dateTime) {
          return 1;
        }
        if (e1.dateTime < e2.dateTime) {
          return -1;
        }

        if (e1.eventType !== e2.eventType) {
          if (e1.eventType === EventType.Outright) {
            return -1;
          } else {
            return 1;
          }
        }

        // if (!ViewConfigurations.orderSpecialsByCode || e1.sportId !== DeployParams.SPECIALS_SPORT_ID || e2.sportId !== DeployParams.SPECIALS_SPORT_ID) {
        if (!ViewConfigurations.orderSpecialsByCode || !environment.specialSportIds.includes(e1.sportId) || !environment.specialSportIds.includes(e2.sportId)) {
          if (e1.eventName > e2.eventName) {
            return 1;
          }
          if (e1.eventName < e2.eventName) {
            return -1;
          }
        }

        if (e1.eventName === e2.eventName) {
          if (e1.code > e2.code) {
            if (e2.mappingType === EventMappingType.SuperBetEvent) {
              return -1;
            } else {
              return 1;
            }
          }
        }
        if (e1.code > e2.code) {
          return 1;
        }
        if (e1.code < e2.code) {
          return -1;
        }

        return 0;
      });
      return events;
    }
  }

  public sortTicketItemGroupsPrintByDateAndCode(events: ITicketItemGroupPrintViewModel[]): ITicketItemGroupPrintViewModel[] {
    if (!events || events.length < 2) {
      return events;
    } else {
      events.sort((e1, e2) => {
        if (e1.eventDateTime > e2.eventDateTime) {
          return 1;
        }
        if (e1.eventDateTime < e2.eventDateTime) {
          return -1;
        }

        if (e1.eventName === e2.eventName) {
          if (e1.eventCode > e2.eventCode) {
            if (e2.mappingType === EventMappingType.SuperBetEvent) {
              return -1;
            } else {
              return 1;
            }
          }
        }
        if (e1.eventCode > e2.eventCode) {
          return 1;
        }
        if (e1.eventCode < e2.eventCode) {
          return -1;
        }

        return 0;
      });
      return events;
    }
  }

  public sortEventsByCodeValueAndLength(events: EventVM[]): EventVM[] {
    if (!events || events.length < 2) {
      return events;
    } else {
      events.sort((e1, e2) => {
        if (e1.code > e2.code || e1.code.length > e2.code.length) {
          return 1;
        }
        if (e1.code < e2.code || e1.code.length > e2.code.length) {
          return -1;
        }
        return 0;
      });
      return events;
    }
  }

  public sortByOrderNumber(list: any[]): any[] {
    if (!list || list.length < 2) {
      return list;
    } else {
      list.sort((e1, e2) => {
        if (e1.orderNumber > e2.orderNumber) {
          return 1;
        }
        if (e1.orderNumber < e2.orderNumber) {
          return -1;
        }
        return 0;
      });
      return list;
    }
  }

  public sortByOrderNo(list: any[]): any[] {
    if (!list || list.length < 2) {
      return list;
    } else {
      list.sort((e1, e2) => {
        if (e1.orderNo > e2.orderNo) {
          return 1;
        }
        if (e1.orderNo < e2.orderNo) {
          return -1;
        }
        return 0;
      });
      return list;
    }
  }

  public sortBetsByOrderingType(bets: IBet[], betOrderingType: BetOrderingType): IBet[] {
    if (!bets || bets.length < 2) {
      return bets;
    } else {
      switch (betOrderingType) {
        case BetOrderingType.ByOddAscending:
          bets.sort((bet1, bet2) => {
            if (bet1.betOutcomes && bet2.betOutcomes && bet1.betOutcomes[0] && bet1.betOutcomes[0]) {
              if (bet1.betOutcomes[0].odd > bet2.betOutcomes[0].odd) {
                return 1;
              }
              if (bet1.betOutcomes[0].odd < bet2.betOutcomes[0].odd) {
                return -1;
              }
            }
            return 0;
          });
          break;
        case BetOrderingType.ByOddDescending:
          bets.sort((bet1, bet2) => {
            if (bet1.betOutcomes && bet2.betOutcomes && bet1.betOutcomes[0] && bet1.betOutcomes[0]) {
              if (bet1.betOutcomes[0].odd < bet2.betOutcomes[0].odd) {
                return 1;
              }
              if (bet1.betOutcomes[0].odd > bet2.betOutcomes[0].odd) {
                return -1;
              }
            }
            return 0;
          });
          break;
        default:
          bets.sort((bet1, bet2) => {
            if (bet1.orderNo > bet2.orderNo) {
              return 1;
            }
            if (bet1.orderNo < bet2.orderNo) {
              return -1;
            }
            return 0;
          });
          break;
      }
      return bets;
    }
  }

  public sortBetsBySbvAsc(bets: IBet[]): IBet[] {
    return bets.sort((bet1, bet2) => {
      if (bet1.sbv && bet2.sbv) {
        if (bet1.sbv > bet2.sbv) {
          return 1;
        }
        if (bet1.sbv < bet2.sbv) {
          return -1;
        }
      }
      return 0;
    });
  }

  public sortBetOutcomesByOrderingType(betOutcomes: IBetOutcome[], betOrderingType: BetOrderingType): IBetOutcome[] {
    if (!betOutcomes || betOutcomes.length < 2) {
      return betOutcomes;
    } else {
      switch (betOrderingType) {
        case BetOrderingType.ByOddAscending:
          betOutcomes.sort((bo1, bo2) => {
            if (bo1.odd > bo2.odd) {
              return 1;
            }
            if (bo1.odd < bo2.odd) {
              return -1;
            }
            return 0;
          });
          break;
        case BetOrderingType.ByOddDescending:
          betOutcomes.sort((bo1, bo2) => {
            if (bo1.odd < bo2.odd) {
              return 1;
            }
            if (bo1.odd > bo2.odd) {
              return -1;
            }
            return 0;
          });
          break;
        default:
          return betOutcomes;

      }
      return betOutcomes;
    }
  }

  getSpecialOfferSportId(specialOfferType?: SpecialOfferType, eventMappingType?: EventMappingType, eventType?: EventType) {
    if (specialOfferType) {
      if (specialOfferType === SpecialOfferType.SuperBet) {
        return -2;
      } else if (specialOfferType === SpecialOfferType.EventOfDay) {
        return -1;
      }
      else if (specialOfferType === SpecialOfferType.Outrights) {
        return -3;
      }
    }

    if (eventMappingType) {
      if (eventMappingType === EventMappingType.SuperBetEvent) {
        return -2;
      } else if (eventMappingType === EventMappingType.EventOfDay) {
        return -1;
      }
    }

    if (eventType) {
      if (eventType === EventType.Outright) {
        return -3;
      }
    }

    return 0;
  }

  getSpecialOfferType(eventMappingType?: EventMappingType, eventType?: EventType): SpecialOfferType {
    if (eventMappingType) {
      if (eventMappingType === EventMappingType.SuperBetEvent) {
        return SpecialOfferType.SuperBet;
      } else if (eventMappingType === EventMappingType.EventOfDay) {
        return SpecialOfferType.EventOfDay;
      }
    }

    if (eventType) {
      if (eventType === EventType.Outright) {
        return SpecialOfferType.Outrights;
      }
    }

    return null;
  }

  // add this dictionary and change function
  public getMostBalancedBetIndex(bets: IBet[], betOutcomesDictionary?: { [betId: number]: IBetOutcome[] }): number {
    let mostBalancedBetIndex = -1;
    // if (bets[0].betOutcomes.length === 2) {
    let index = 0;
    let difference = 999999;
    bets.forEach(bet => {
      if (!betOutcomesDictionary) {
        if (bet.betOutcomes?.length === 2 && bet.isPlayable) {
          const diff = Math.abs(bet.betOutcomes[0].odd - bet.betOutcomes[1].odd);
          if (diff < difference) {
            difference = diff;
            mostBalancedBetIndex = index;
          }
        }
      } else {
        if (betOutcomesDictionary && betOutcomesDictionary[bet.id]?.length === 2 && bet.isPlayable) {
          const diff = Math.abs(betOutcomesDictionary[bet.id][0].odd - betOutcomesDictionary[bet.id][1].odd);
          if (diff < difference) {
            difference = diff;
            mostBalancedBetIndex = index;
          }
        }
      }
      index++;
    });
    // }
    return mostBalancedBetIndex;
  }

  public getMostBalancedBetIndexFromBetProperty(bets: IBet[]): number {
    return bets.findIndex(b => b.isMostBalanced);
  }

  public getBetTypeGroupForAll(): IBetTypeGroup {
    return {
      id: -1,
      betTypeIds: null,
      name: 'All',
      betTypeGroupingTemplateItems: null,
      isSelected: false,
      isUserFavoriteButton: false,
      isOnline: false,
    };
  }

  //  use it first time when outcome is get to set name, dont use on updates
  public getBetOutcomeNameFromBTO(outcome: IBetOutcome, betTypeShowType: IBetTypeShowType, homeTeam: string, awayTeam: string, eventType: EventType): string {
    // For Outrights name is preset
    if (eventType === EventType.Outright) {
      if (betTypeShowType.betTypeOutcomes && betTypeShowType.betTypeOutcomes[outcome.betTypeOutcomeId]) {
        if (!this.isMobileView) {
          if (betTypeShowType.betTypeOutcomes[outcome.betTypeOutcomeId].desktopShowType === BetTypeOutcomeShowType.ParticipantName) {
            return '';
          }
        } else {
          if (betTypeShowType.betTypeOutcomes[outcome.betTypeOutcomeId].mobileShowType === BetTypeOutcomeShowType.ParticipantName) {
            return '';
          }
        }
      }
      return outcome.name;
    }

    let btoName = '';
    const betTypeOutcomes = betTypeShowType ? betTypeShowType.betTypeOutcomes : null;
    if (betTypeOutcomes) {
      const betTypeOutcome: IBetTypeOutcome = betTypeOutcomes[outcome.betTypeOutcomeId];
      if (betTypeOutcome) {
        if (outcome != null) {
          outcome.orderNo = betTypeOutcome.orderNumber;
          outcome.description = betTypeOutcome.descriptions;
        }
        if (!this.isMobileView) {
          switch (betTypeOutcome.desktopShowType) {
            case BetTypeOutcomeShowType.BTOFullName: {
              btoName = betTypeOutcome.name;
              break;
            }
            case BetTypeOutcomeShowType.BTOShortName: {
              btoName = betTypeOutcome.shortName;
              break;
            }
            case BetTypeOutcomeShowType.Custom: {
              btoName = betTypeOutcome.customName.replace(/\[SBV\]/g, outcome.sbv).replace(/\[P1\]/g, homeTeam).replace(/\[P2\]/g, awayTeam);
              break;
            }
            case BetTypeOutcomeShowType.ParticipantName: {
              if (betTypeOutcome.name === '1') {
                btoName = homeTeam;
              }
              if (betTypeOutcome.name === '2') {
                btoName = awayTeam;
              }
              break;
            }
            case BetTypeOutcomeShowType.None: {
              btoName = '';
              break;
            }
            default:
              btoName = outcome.name;
              break;
          }
        } else {
          switch (betTypeOutcome.mobileShowType) {
            case BetTypeOutcomeShowType.BTOFullName: {
              btoName = betTypeOutcome.name;
              break;
            }
            case BetTypeOutcomeShowType.BTOShortName: {
              btoName = betTypeOutcome.shortName;
              break;
            }
            case BetTypeOutcomeShowType.Custom: {
              btoName = betTypeOutcome.customName.replace(/\[SBV\]/g, outcome.sbv).replace(/\[P1\]/g, homeTeam).replace(/\[P2\]/g, awayTeam);
              break;
            }
            case BetTypeOutcomeShowType.ParticipantName: {
              if (betTypeOutcome.name === '1') {
                btoName = homeTeam;
              }
              if (betTypeOutcome.name === '2') {
                btoName = awayTeam;
              }
              break;
            }
            case BetTypeOutcomeShowType.None: {
              btoName = '';
              break;
            }
            default:
              btoName = outcome.name;
              break;
          }
        }
      }
    }
    return btoName;
  }


  public createBetsGroup(): IBetGroupWithBetToShowId {
    return {
      betToShow: null,
      bets: {}
    };
  }

  public roundByBusinessModel(numberToRound: number): number {
    switch (ConstantValues.NUMBER_ROUNDING) {
      case OfficeNumberRounding.WholeNumber:
        numberToRound = Math.round(numberToRound);
        break;
      case OfficeNumberRounding.HalfNumber:
        numberToRound = Math.round(numberToRound * 2) / 2;
        break;
      case OfficeNumberRounding.OneDecimal:
        numberToRound = Math.round(numberToRound * 10) / 10;
        break;
      case OfficeNumberRounding.TwoDecimal:
        numberToRound = Math.round(numberToRound * 100) / 100;
        break;
      case OfficeNumberRounding.ThreeDecimal:
        numberToRound = Math.round(numberToRound * 1000) / 1000;
        break;
      case OfficeNumberRounding.FourDecimal:
        numberToRound = Math.round(numberToRound * 10000) / 10000;
        break;
    }

    return numberToRound;
  }


  private round(value, precision) {
    const multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
  }


  selectBetOutcomeFromEvents(events: { [id: number]: EventVM }, identifier: ITicketItemIdentifier) {
    const betOutcome = this.findBetOutcome(events, identifier.eventId, identifier.betTypeId, identifier.betId, identifier.betTypeOutcomeId, identifier.betOutcomeId);
    if (betOutcome) {
      if (identifier.isAdded) {
        betOutcome.isSelected = true;
      } else {
        betOutcome.isSelected = false;
      }
    }
  }

  findBetOutcome(events: { [id: number]: EventVM }, eventId: number, betTypeId: number, betId: number, betTypeOutcomeId: number, betoutcomeId: number): IBetOutcome {
    if (events[eventId]) {
      if (events[eventId].betGroups[betTypeId]) {
        const bet = events[eventId].betGroups[betTypeId].bets[betId];
        if (bet) {
          if (bet.betOutcomesDic[betTypeOutcomeId]) {
            const betOutcome = bet.betOutcomesDic[betTypeOutcomeId].find(bo => bo.id === betoutcomeId);
            if (betOutcome) {
              return betOutcome;
            }
          }
        }
      }
    }
    return null;
  }

  getSportIcon(sportId: number): string {
    let sportString: string;
    switch (sportId) {
      case 0:
        sportString = 'sporticon-all';
        break;
      case 1:
        sportString = 'sporticon-soccer';
        break;
      case 2:
        sportString = 'basketball';
        break;
      case 3:
        sportString = 'sporticon-tennis';
        break;
      case 4:
        sportString = 'ice-hockey';
        break;
      case 5:
        sportString = 'baseball';
        break;
      case 6:
        sportString = 'sporticon-handball';
        break;
      case 7:
        sportString = 'floorball';
        break;
      case 8:
        sportString = 'sporticon-golf';
        break;
      case 9:
        sportString = 'boxing';
        break;
      case 36:
        sportString = 'ufc-mma';
        break;
      case 10:
      case 62:
        sportString = 'formula1';
        break;
      case 11:
        sportString = 'rugby';
        break;
      case 12:
        sportString = 'aussie-rules';
        break;
      case 13:
        sportString = 'winter-sports';
        break;
      case 14:
        sportString = 'bandy';
        break;
      case 15:
        sportString = 'american-football';
        break;
      case 16:
        sportString = 'snooker';
        break;
      case 17:
        sportString = 'table-tennis';
        break;
      case 18:
        sportString = 'sporticon-cricket';
        break;
      case 19:
        sportString = 'darts';
        break;
      case 20:
        sportString = 'volleyball';
        break;

      case 21:
        sportString = 'field-hockey';
        break;
      case 22:
        sportString = 'waterpolo';
        break;
      // case 23:
      //   sportString = 'curling';
      //   break;
      case 24:
        sportString = 'futsal';
        break;
      case 25:
        sportString = 'badminton';
        break;
      // case 26:
      //   sportString = 'bowls';
      //   break;
      case 27:
        sportString = 'beach-volley';
        break;
      case 28:
        sportString = 'squash';
        break;
      case 29:
        sportString = 'beach-soccer';
        break;
      case 30:
        sportString = 'pesapallo';
        break;

      case 39:
        sportString = 'cycling';
        break;

      case 32:
      case 33:
      case 34:
      case 35:
      case 37:
      case 38:
      case 69:
      case 70:
      case 72:
      case 73:
      case 81:
        sportString = 'sporticon-esports';
        break;
      case 60:
        sportString = 'sporticon-race';
        break;

      default: sportString = 'sporticon-all';
    }

    return sportString;
  }

  isSearchValid(searchValue: string): { searchValue: string; searchMessage: string; isSearchValid: boolean } {
    const result: { searchValue: string; searchMessage: string; isSearchValid: boolean } = { searchValue, searchMessage: '', isSearchValid: true };

    result.searchValue = searchValue.replace(/^\s+/g, '').split(/\s+/).join(' ');


    if (result.searchValue.startsWith(' ')) {
      result.searchMessage = DynamicTranslations.searchForMatch_searchErrorMessage_spaceForbidden;
      result.isSearchValid = false;
      return result;
    }

    if (result.searchValue.length < ConstantValues.SEARCH_VALUE_MIN_LENGTH) {
      result.searchMessage = DynamicTranslations.searchForMatch_searchErrorMessage_minLengthPart1 + ' ' + ConstantValues.SEARCH_VALUE_MIN_LENGTH + ' ' + DynamicTranslations.searchForMatch_searchErrorMessage_minLengthPart2;
      result.isSearchValid = false;
      return result;
    }

    if (!/^[\w.čćžšđ\s]+$/i.test(result.searchValue)) {
      result.searchMessage = DynamicTranslations.searchForMatch_searchErrorMessage_specialCharactersForbiden;
      result.isSearchValid = false;
      return result;
    }

    if (result.searchValue.length > ConstantValues.SEARCH_VALUE_MAX_LENGTH) {
      result.searchMessage = DynamicTranslations.searchForMatch_searchErrorMessage_maxLengthPart1 + ' ' + ConstantValues.SEARCH_VALUE_MAX_LENGTH + ' ' + DynamicTranslations.searchForMatch_searchErrorMessage_maxLengthPart2;
      result.isSearchValid = false;
      return result;
    }

    result.searchMessage = '';
    result.isSearchValid = true;

    return result;
  }


  getTicketFilterString(status: TicketFilterStatus) {
    switch (status) {
      case TicketFilterStatus.Active:
        return 'A';

      case TicketFilterStatus.Win:
        return 'W';

      case TicketFilterStatus.Cashout:
        return 'C';

      case TicketFilterStatus.Lost:
        return 'L';

      case TicketFilterStatus.Storno:
        return 'V';

      case TicketFilterStatus.Cashback:
        return 'CB';

      case TicketFilterStatus.Expired:
        return 'E';
      default:
        return null;
    }
  }
  // PRIMER https://www.admiral.hr/app/sport?competitionId=1-1056-17661&event=533011&sport="Fudbal"&region="Engleska"&competition="PremierLiga"&eventName="Machester-Chelsea"
  public changeParentSrcUrl(
    sportId?: number,
    sportName?: string,
    regionId?: number,
    regionName?: string,
    competitionId?: number,
    competitionName?: string) {

    const parentUrl = parent.window.location.href;
    let setUrl: string;

    if (!sportId) {
      // obrisi iz linka parametre competitionId, event, sport, region, competition, eventName
      // PRIMER https://www.admiral.hr/app/sport
      // setUrl = this.removeParametarFromUrl(parentUrl, ['competitionId=', 'event=', 'sport=', 'region=', 'competition=', 'eventName=']);

      if (parentUrl.includes('?')) {
        setUrl = parentUrl.split('?')[0];
      }
    } else {
      // sport = sportName
      sportName = sportName.split(' ').join('_');
      setUrl = this.changeParametarFromUrl(parentUrl, 'sport=', sportName);

      if (!regionId) {
        // brise se competitionId, competition, region, event i eventName; ostaje sport
        // PRIMER https://www.admiral.hr/app/sport?sport="Fudbal"
        setUrl = this.removeParametarFromUrl(setUrl, ['competitionId=', 'event=', 'region=', 'competition=', 'eventName=']);
      } else {
        // region= regionName
        regionName = regionName.split(' ').join('_');
        setUrl = this.changeParametarFromUrl(setUrl, 'region=', regionName);

        if (!competitionId) {
          // brise se competition, event i eventName; ostaje sport, competitionId, region (kod competitionId ostaju samo 2 parametra )
          setUrl = this.removeParametarFromUrl(setUrl, ['event=', 'competition=', 'eventName=']);
          // PRIMER https://www.admiral.hr/app/sport?competitionId=1-1056&sport="Fudbal"&region="Engleska"
          setUrl = this.changeParametarFromUrl(setUrl, 'competitionId=', sportId.toString() + '-' + regionId.toString());
          // competitionID=sportID-RegionId
        } else {
          // competition = competitionName
          // competitionID = sportID-RegionId-comnpetitionId
          competitionName = competitionName.split(' ').join('_');
          setUrl = this.changeParametarFromUrl(setUrl, 'competition=', competitionName);
          setUrl = this.changeParametarFromUrl(setUrl, 'competitionId=', sportId.toString() + '-' + regionId.toString()  + '-' + competitionId.toString());
        }
      }
    }

    parent.window.history.pushState('data', parent.document.title, setUrl);
  }
  public changeParentEventUrl(
    eventId?: number,
    eventName?: string) {

    const parentUrl = parent.window.location.href;
    let setUrl: string;

    if (!eventId) {
      // brise se  event i eventName;
      // PRIMER https://www.admiral.hr/app/sport?competitionId=1-1056-17661&sport="Fudbal"&region="Engleska"&competition="PremierLiga"
      if (parentUrl.includes('event=')) {
        setUrl = this.removeParametarFromUrl(parentUrl, ['event=', 'eventName=']);
      }
      // if (parentUrl.includes('eventName=')) {
      //   setUrl = this.removeParametarFromUrl(setUrl, 'eventName=');
      // }
    } else {
      // eventName = eventName
      // event = EventId
      eventName = eventName.split(' ').join('_');

      setUrl = this.changeParametarFromUrl(parentUrl, 'event=', eventId.toString());
      setUrl = this.changeParametarFromUrl(setUrl, 'eventName=', eventName);
    }

    parent.window.history.pushState('data', parent.document.title, setUrl);
  }

  private removeParametarFromUrl(url: string, paramsName: Array<string>): string {
    if (url.includes('?')) {
      const baseUrl = url.split('?')[0];
      const params = url.split('?')[1];
      const paramsArray = params.split('&');
      // const index = paramsArray.findIndex(x => x.includes(paramName));

      paramsName.forEach(paramName => {
        const index = paramsArray.findIndex(x => x.includes(paramName));
        // remove param from array
        if (index !== -1) {
          paramsArray.splice(index, 1);
        }
      });

      return this.createUrl(paramsArray, baseUrl);
    }

    // paramsArray.splice(index, 1);

  }

  private changeParametarFromUrl(url: string, paramName: string, paramValue: string): string {
    if (url.includes('?')) {
      const baseUrl = url.split('?')[0];
      const params = url.split('?')[1];
      const paramsArray = params.split('&');
      const index = paramsArray.findIndex(x => x.includes(paramName));

      if (index === -1) {
        // add new param
        paramsArray.push(paramName + paramValue);
      } else {
        // change exist param
        paramsArray[index] = paramName + paramValue;
      }
      return this.createUrl(paramsArray, baseUrl);

    } else {
      return url + '?' + paramName + paramValue;
    }


  }

  private createUrl(paramsArray: Array<string>, baseUrl: string): string {
    let returnUrl;
    if (paramsArray.length > 0) {
      paramsArray.forEach((x, index) => {
        if (index === 0) {
          returnUrl = baseUrl + '?' + x;
        } else {
          returnUrl += '&' + x;
        }
      });
    } else {
      returnUrl = baseUrl;
    }

    return returnUrl;
  }

  // confirmDialog(id: number, message: string = null, , okButtonText: string = null, cancelButtonText: string = null) {
  //   const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
  //     data: {
  //       message: message ? message : 'Are you sure you want to delete?',
  //       buttonText: {
  //         ok: okButtonText ? okButtonText : 'Yes',
  //         cancel: cancelButtonText ? cancelButtonText : 'No',
  //       },
  //     },
  //     panelClass: 'custom-box'
  //   });
  //   // const snack = this.snackBar.open('Snack bar open before dialog');

  //   dialogRef.afterClosed().subscribe((confirmed: boolean) => {
  //     if (confirmed) {
  //       this.deleteShop(id);
  //     }
  //   });
  // }

  convertStringToDate(dateString: string, errorSource: string): Date {
    let dateStringZ = '';
    if (dateString) {
      dateStringZ = dateString.replace('Z', '') + 'Z';
    } else {
      dateStringZ = dateString;
    }
    if (dateStringZ) {
      const date = new Date(dateStringZ);
      if (dateStringZ && date instanceof Date && !isNaN(+date)) {
        return new Date(dateStringZ);
      } else {
        // console.error('invalid string for date format from ' + errorSource + ' dateString = ' + dateString);
        return new Date();
      }
    } else {
      // console.error('invalid string for date format from ' + errorSource + ' dateString = ' + dateString);
      return new Date();
    }
  }

  generatePdfFromTicket(htmlTicket: HTMLElement, ticketId: string) {
    const htmlTicketClone: HTMLElement = htmlTicket.cloneNode(true) as HTMLElement;
    const ticketForPdf = htmlTicketClone.children[0] as HTMLElement;
    (ticketForPdf.getElementsByClassName('ticket-option')[0] as HTMLElement)?.remove();
    (ticketForPdf.getElementsByClassName('exportToPdf')[0] as HTMLElement)?.remove();
    (ticketForPdf.getElementsByClassName('close')[0] as HTMLElement)?.remove();
    const rows = ticketForPdf.getElementsByClassName('row');
    const btn = ticketForPdf.getElementsByClassName('btn');


    (ticketForPdf.getElementsByClassName('system-description')[0] as HTMLElement).style.top = '-18px';
    (ticketForPdf.getElementsByClassName('system-value')[0] as HTMLElement).style.paddingTop = '18px';

    const spans = ticketForPdf.getElementsByTagName('span');
    for (let j = 0; j < spans.length; j++) {
      ticketForPdf.getElementsByTagName('span')[j].style.color = 'black';
    }

    for (let i = 0; i < btn.length; i++) {
      (ticketForPdf.getElementsByClassName('btn')[i] as HTMLElement).style.background = 'white';
      (ticketForPdf.getElementsByClassName('btn')[i] as HTMLElement).style.color = 'black';
      (ticketForPdf.getElementsByClassName('btn')[i] as HTMLElement).style.borderColor = 'white';
    }

    for (let i = 0; i < rows.length; i++) {
      (ticketForPdf.getElementsByClassName('row')[i] as HTMLElement).style.background = 'white';
    }
    ticketForPdf.style.maxHeight = 'none';
    ticketForPdf.style.background = 'white ';
    ticketForPdf.style.color = 'black ';
    ticketForPdf.style.borderColor = 'white ';

    htmlTicketClone.style.top = '-150%';


    (ticketForPdf.getElementsByClassName('ticket-detail-body')[0] as HTMLElement).style.overflow = 'auto';
    (ticketForPdf.getElementsByClassName('ticket-detail-body')[0] as HTMLElement).style.height = '100%';
    (ticketForPdf.getElementsByClassName('ticket-detail-body')[0] as HTMLElement).style.width = '100%';

    document.body.appendChild(htmlTicketClone);
    html2canvas(ticketForPdf).then((canvas) => {
      const fileWidth = 208;
      const fileHeight = (canvas.height * fileWidth) / canvas.width;
      const FILEURI = canvas.toDataURL('image/png');
      const PDF = new jsPDF('p', 'mm', 'a4');
      const position = 0;
      PDF.addImage(FILEURI, 'png', 0, position, fileWidth, fileHeight);
      PDF.save(ticketId + '.pdf');

      document.body.removeChild(htmlTicketClone);
    });
  }
}
